import { SystemStyleObject } from "@chakra-ui/react";

export const businessTableCTACss: SystemStyleObject = {
  width: "52px",
  height: "40px",
  boxShadow: "0px 0px 0px 1px #122B6914",
  borderRadius: "8px",
  padding: "10px",
  color: "#1A202C",
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 600,
};

export const businessTypeCss: SystemStyleObject = {
  height: "22px",
  borderRadius: "16px",
  padding: "2px 8px",
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "18px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const businessTableColumnCss: SystemStyleObject = {
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 400,
  color: "#667085",
};
